import React from "react";
import { localizedTransactionStatus } from "../../../intl/shared-resources/transactionStatus.js";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { removeItemsFromArray } from "../../../utils/array.js";
import "react-intl";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import { SelectFilter } from "../../../components/filter/SelectFilter.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/Select.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { ReasonCode, TransactionStatus } from "../../../contract/pam.js";
import { TransactionStatusTypeName } from "../constants.js";
import { localizedReasonCode } from "../sharedLocalization.js";
const onHoldRiskReasons = [
  { label: localizedReasonCode[ReasonCode.UnderInvestigation], value: "OnHoldRisk.UnderInvestigation" },
  { label: localizedReasonCode[ReasonCode.Threshold24hrs], value: "OnHoldRisk.Threshold24hrs" },
  { label: localizedReasonCode[ReasonCode.KycPending], value: "OnHoldRisk.KYCPending" },
  { label: localizedReasonCode[ReasonCode.PspNoFunds], value: "OnHoldRisk.PSPNoFunds" },
  { label: localizedReasonCode[ReasonCode.GameplayReview], value: "OnHoldRisk.GameplayReview" },
  { label: localizedReasonCode[ReasonCode.MgmtReview], value: "OnHoldRisk.MgmtReview" },
  { label: localizedReasonCode[ReasonCode.Other], value: "OnHoldRisk.Other" }
];
const onHoldPaymentReasons = [
  { label: localizedReasonCode[ReasonCode.UnderInvestigation], value: "OnHoldPayment.UnderInvestigation" },
  { label: localizedReasonCode[ReasonCode.Threshold24hrs], value: "OnHoldPayment.Threshold24hrs" },
  { label: localizedReasonCode[ReasonCode.KycPending], value: "OnHoldPayment.KYCPending" },
  { label: localizedReasonCode[ReasonCode.PspNoFunds], value: "OnHoldPayment.PSPNoFunds" },
  { label: localizedReasonCode[ReasonCode.GameplayReview], value: "OnHoldPayment.GameplayReview" },
  { label: localizedReasonCode[ReasonCode.MgmtReview], value: "OnHoldPayment.MgmtReview" },
  { label: localizedReasonCode[ReasonCode.Other], value: "OnHoldPayment.Other" }
];
const subOptionMapper = {
  [TransactionStatus.OnHoldRisk]: onHoldRiskReasons,
  [TransactionStatus.OnHoldPayment]: onHoldPaymentReasons
};
const subOptionValuesMapper = {
  [TransactionStatus.OnHoldRisk]: onHoldRiskReasons?.map((o) => o?.value),
  [TransactionStatus.OnHoldPayment]: onHoldPaymentReasons?.map((o) => o?.value)
};
function useTransactionStatusFilter(withReasons) {
  function filterValueToStatusArray(value) {
    let filterValue = value?.map(
      (v) => withReasons && v?.reason ? `${v?.status}.${v?.reason}` : v?.status
    );
    if (withReasons) {
      Object.entries(subOptionValuesMapper).forEach(
        ([status, subOptionsValues]) => {
          if (filterValue?.includes(status)) {
            filterValue = removeItemsFromArray(filterValue, status);
            filterValue.push(...subOptionsValues);
          }
        }
      );
    }
    return [...new Set(filterValue)];
  }
  function statusArrayToFilterValue(statuses) {
    let result = [];
    if (typeof statuses !== "string" && statuses?.length) {
      let resultStatuses = statuses;
      Object.entries(subOptionValuesMapper).forEach(
        ([status, subOptionsValues]) => {
          if (subOptionsValues?.every((v) => statuses?.includes(v))) {
            resultStatuses = removeItemsFromArray(resultStatuses, ...subOptionsValues);
            resultStatuses.push(status);
          }
        }
      );
      resultStatuses?.forEach((v) => {
        const slices = v?.split(".");
        if (slices?.length > 1) {
          result.push({ status: slices[0], reason: slices[1] });
        } else {
          result.push({ status: slices[0] });
        }
      });
    } else {
      result = void 0;
    }
    return result;
  }
  function getOptions(statuses) {
    return statuses?.map((s) => {
      const subOptions = withReasons ? subOptionMapper[s] : void 0;
      return {
        label: localizedTransactionStatus[s],
        value: subOptions?.length ? subOptions?.map((o) => o?.value) : s,
        chipValue: s,
        subOptions
      };
    });
  }
  return { filterValueToStatusArray, statusArrayToFilterValue, getOptions };
}
function TransactionStatusFilter({ value, onChange, label, options, withReasons = true }) {
  const { filterValueToStatusArray, statusArrayToFilterValue, getOptions } = useTransactionStatusFilter(withReasons);
  const filterValue = filterValueToStatusArray(value);
  const selectOptions = getOptions(options);
  function handleChange(statuses) {
    const newValue = statusArrayToFilterValue(statuses);
    onChange(newValue);
  }
  return /* @__PURE__ */ React.createElement(
    SelectFilter,
    {
      multiple: true,
      label,
      value: filterValue,
      chipType: TransactionStatusTypeName,
      options: selectOptions,
      onChange: handleChange
    }
  );
}
export {
  TransactionStatusFilter,
  useTransactionStatusFilter
};
//# sourceMappingURL=StatusFilter.js.map
